module.exports = __webpack_public_path__ + "media/images/front/services/production-3256486bc00da8348c97bea0acc8b9a6.jpg";